module.exports = __webpack_public_path__ + "img/Rectangle 145@2x.f791a5b2.png";